import type { Position } from "@/pages/human-resources/time-management/business/Position.ts";

export type PositionOut = Omit<Position, "id"> & {
  id: number;
};

export function mapToPosition(s: PositionOut): Position {
  return { ...s, id: s.id.toString() };
}
